/*
 * Public API Surface of ionic-vhframeworks
 */

export * from './lib/ionic-vhframeworks.service';
export * from './lib/ionic-vhframeworks.component';
export * from './lib/ionic-vhframeworks.module';
